/* eslint-disable no-unused-vars */
import { TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";

export default function PSelect(props) {
  return (
    <Autocomplete
      style={props.style}
      id="auto_dept"
      options={props.options}
      filterOptions={props.filterOptions}
      // isOptionEqualToValue={props.isOptionEqualToValue}
      // onInputChange={props.handleInputChange}
      getOptionLabel={(option) => {
        return option && option.name ? option.name : "";
      }}
      disabled={props.disabled}
      value={props.value}
      onChange={(event, newValue) => {
        if (props.onChange) props.onChange(event, newValue);
      }}
      disableClearable
      isOptionEqualToValue={(option, value) => {
        if (value == "") return false;
        if (value.id) {
          return option.id === value.id;
        }
        if (value.code && option.code) {
          return option.code === value.code;
        }
        return false;
      }}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            variant="outlined"
            size={props.size}
            label={props.label}
            placeholder={props.placeholder}
            error={
              (props.errorMessage && props.errorMessage.length) > 0
                ? true
                : false
            }
            helperText={
              props.errorMessage && props.errorMessage != " "
                ? props.errorMessage
                : ""
            }
            onFocus={(e) => {
              if (props.onFocus) props.onFocus(e);
            }}
            onBlur={(e) => {
              if (props.onBlur) props.onBlur(e);
            }}
            inputProps={{
              ...params.inputProps,
              style: {
                padding: "4px",
              },
            }}
            InputLabelProps={{ shrink: true }}
          />
        );
      }}
    />
  );
}
